
import { ToastFactory } from '@/utils/ToastFactory';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import UserService from '@/views/Users/user.service';
import i18n from '@/utils/i18n';
const userService = new UserService();

export default defineComponent({
  name: 'Home',
  data() {
      return {
          userInfo: {} as any,
          user: {} as any,
          selectedLanguage: null,
          languages: [
              { name: 'Português', value: 'pt', code: 'BR' },
              { name: 'Inglês', value: 'en', code: 'US' },
          ] as any,
      };
  },

  watch:{

  },

  computed:{
        ...mapGetters({
            storeUserInfo: "users/getUserInfo",
        }),
  },

  methods:{
    async getUserInfo(){
      userService.getUserInfo().then(() => {
        this.userInfo = this.storeUserInfo;
      });
    },

    sendUserInfo(): void{
      this.user.name = this.userInfo.name;
      this.user.phone = this.userInfo.phone;
      this.user.id = this.userInfo.id;
      this.user.email = this.userInfo.email;
      this.user.cpf = this.userInfo.cpf;
      
      userService.updateUser(this.user.id, this.user)
      .then(() => {
        this.$toast.add(ToastFactory.success(this.$t('toast.sucessUpdateInfo')));
        this.getUserInfo();
        localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
      }).catch(() => {
        this.$toast.add(ToastFactory.error(this.$t('toast.errorUpdateInfo')));
      });
    },

    changeLanguage(language: any) {
      i18n.global.locale = language;
      this.$cookies.set("userLang",language, "30d" )
    },


  },

  mounted(){
    this.getUserInfo();
  }
});
